// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_centered-col__hWHwH {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.styles_hide-scrollbar__7bvEE {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .styles_hide-scrollbar__7bvEE::-webkit-scrollbar {
    display: none; }

.styles_singleLineText__CyRDB {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.styles_width-fill-available__mhjhJ {
  width: 100%;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available; }

.styles_height-fill-available__k-h2s {
  height: 100%;
  /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  height: fill-available; }

@keyframes styles_drop__vSeru {
  0% {
    transform: translateY(0vh); }
  75% {
    transform: translateY(75vh); }
  100% {
    transform: translateY(100vh); } }

@keyframes styles_ascend__24bqS {
  0% {
    transform: translateY(100vh); }
  75% {
    transform: translateY(75vh); }
  100% {
    transform: translateY(0vh); } }

@keyframes styles_pulsating__P8BrF {
  0% {
    transform: scale(1);
    background-color: #808080b8;
    opacity: 0.18; }
  50% {
    transform: scale(1.8);
    background-color: #3c3b3b;
    opacity: 0.72; }
  100% {
    transform: scale(1);
    background-color: #808080e6;
    opacity: 0.18; } }

.styles_node__KrAlJ {
  position: absolute;
  background-color: #3c3b3b;
  border-radius: 100%;
  height: 1.8rem;
  width: 1.8rem;
  overflow: hidden;
  transition: 1s all ease-in;
  border: 0.1rem solid #808080;
  cursor: pointer;
  transform: translateX(-0.9rem) translateY(0.9rem);
  z-index: 2;
  overflow: visible;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  z-index: 1; }
  .styles_node__KrAlJ.styles_extra-small__Vvu0B {
    max-height: 0.5rem;
    max-width: 0.5rem;
    z-index: -1; }
  .styles_node__KrAlJ.styles_dropping__GzSsX {
    animation: styles_drop__vSeru 10s linear infinite; }
  .styles_node__KrAlJ.styles_ascending__mY1d5 {
    animation: styles_ascend__24bqS 10s linear infinite; }
  .styles_node__KrAlJ.styles_pulsating__P8BrF {
    animation: styles_pulsating__P8BrF 5s linear infinite; }
  .styles_node__KrAlJ.styles_quote__W7AiS .styles_textContentContainer__oOI0n {
    display: flex;
    flex-direction: column-reverse; }
    .styles_node__KrAlJ.styles_quote__W7AiS .styles_textContentContainer__oOI0n h4 {
      font-size: 1rem;
      text-align: right;
      width: 100%; }
  .styles_node__KrAlJ.styles_quote__W7AiS .styles_btn__v88WE {
    align-self: flex-start;
    align-self: center; }
    .styles_node__KrAlJ.styles_quote__W7AiS .styles_btn__v88WE::after {
      display: none; }
  .styles_node__KrAlJ .styles_elipsis__LrC3C {
    border-width: 0.25rem;
    border-color: #8080800d;
    border-style: ridge;
    padding: 0.07rem;
    width: 120%;
    height: 150%;
    border-radius: 100%;
    position: absolute;
    opacity: 0.25;
    transform: 1s all ease-in; }
    .styles_node__KrAlJ .styles_elipsis__LrC3C:nth-child(2) {
      rotate: 90deg; }
    .styles_node__KrAlJ .styles_elipsis__LrC3C:nth-child(3) {
      rotate: 180deg; }
    .styles_node__KrAlJ .styles_elipsis__LrC3C:nth-child(4) {
      rotate: 342deg; }
    .styles_node__KrAlJ .styles_elipsis__LrC3C:nth-child(5) {
      rotate: 216deg; }
  .styles_node__KrAlJ > div:first-child {
    z-index: 10;
    display: none;
    justify-content: center;
    flex-direction: column; }
  .styles_node__KrAlJ.styles_open__N6CRM {
    z-index: 9999909999;
    border: 0.1rem solid #8080801a;
    background-color: #fff; }
    .styles_node__KrAlJ.styles_open__N6CRM > div:first-child {
      display: flex;
      background-color: #8080802e;
      border-radius: 100%;
      padding: 1.8rem;
      height: 90%;
      width: 90%;
      overflow: hidden; }
      .styles_node__KrAlJ.styles_open__N6CRM > div:first-child p {
        font-size: 1.1rem;
        margin: unset;
        font-weight: 600;
        line-height: 1.25rem; }
        @media (max-width: 768px) {
          .styles_node__KrAlJ.styles_open__N6CRM > div:first-child p {
            font-size: 0.75rem; } }
    .styles_node__KrAlJ.styles_open__N6CRM .styles_elipsis__LrC3C {
      opacity: 0.5;
      border-color: #8080802e;
      border-width: 0.18rem;
      width: 107%;
      height: 136%;
      padding: unset; }
    .styles_node__KrAlJ.styles_open__N6CRM.styles_medium__q7fSk {
      height: 18rem;
      width: 18rem;
      transform: translateX(-9.9rem) translateY(9.9rem); }
    .styles_node__KrAlJ.styles_open__N6CRM.styles_small__N9OQd {
      height: 15rem;
      width: 15rem;
      transform: translateX(-8.4rem) translateY(8.4rem); }
    .styles_node__KrAlJ.styles_open__N6CRM.styles_large__xb8i8 {
      height: 30rem;
      width: 30rem;
      transform: translateX(-15.9rem) translateY(15.9rem); }
    .styles_node__KrAlJ.styles_open__N6CRM h4 {
      margin: unset;
      font-weight: 800;
      font-size: 1.5rem; }
      @media (max-width: 768px) {
        .styles_node__KrAlJ.styles_open__N6CRM h4 {
          font-size: 0.9rem; } }

.styles_btn__v88WE {
  transform: 1s all ease-in;
  color: #808080e6 !important;
  width: fit-content;
  align-self: flex-end;
  max-width: 90%;
  display: flex;
  align-items: center;
  max-height: 1.8rem; }
  .styles_btn__v88WE::after {
    transition: 0.5s all;
    content: "\\203A";
    font-size: 1.5rem;
    color: #808080e6;
    cursor: pointer;
    padding: 0rem 0.5rem;
    display: flex;
    align-items: center;
    height: 100%; }
  .styles_btn__v88WE:hover {
    color: #3c3b3b;
    opacity: 1;
    font-weight: 700;
    background-color: unset; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/classes.scss","webpack://./src/modules/Core/components/screens/LandingPage/Node/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACY,4CAAA;EACvB,6BAA6B;EAAE,6CAAA;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACY,4CAAA;EACxB,8BAA8B;EAAE,6CAAA;EAChC,sBAAsB,EAAA;;AC5BxB;EACE;IACE,0BAA0B,EAAA;EAG5B;IACE,2BAA2B,EAAA;EAE7B;IACE,4BAA4B,EAAA,EAAA;;AAIhC;EACE;IACE,4BAA4B,EAAA;EAE9B;IACE,2BAA2B,EAAA;EAE7B;IACE,0BAA0B,EAAA,EAAA;;AAG9B;EACE;IACE,mBAAmB;IACnB,2BCdc;IDed,aAAa,EAAA;EAEf;IACE,qBAAqB;IACrB,yBAAyB;IACzB,aAAa,EAAA;EAEf;IACE,mBAAmB;IACnB,2BCvBc;IDwBd,aAAa,EAAA,EAAA;;AAIjB;EACE,kBAAkB;EAClB,yBAAyB;EAEzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,4BCpCY;EDqCZ,eAAe;EACf,iDAAiD;EACjD,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EAuEnB,UAAU,EAAA;EAxFZ;IAmBI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW,EAAA;EArBf;IAyBI,iDAAmC,EAAA;EAzBvC;IA6BI,mDAAqC,EAAA;EA7BzC;IAiCI,qDAAuC,EAAA;EAjC3C;IAsCM,aAAa;IACb,8BAA8B,EAAA;IAvCpC;MAyCQ,eAAe;MACf,iBAAiB;MACjB,WAAW,EAAA;EA3CnB;IA+CM,sBAAsB;IACtB,kBAAkB,EAAA;IAhDxB;MAkDQ,aAAa,EAAA;EAlDrB;IAwDI,qBAAqB;IACrB,uBC7Fa;ID8Fb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB,EAAA;IAjE7B;MAoEM,aAAa,EAAA;IApEnB;MAuEM,cAAc,EAAA;IAvEpB;MA2EM,cAAc,EAAA;IA3EpB;MA+EM,cAAc,EAAA;EA/EpB;IAmFI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,sBAAsB,EAAA;EAtF1B;IA0FI,mBAAmB;IA4BnB,8BCxJc;IDwKd,sBAAsB,EAAA;IAtI1B;MA4FM,aAAa;MACb,2BC9HY;MD+HZ,mBAAmB;MACnB,eAAe;MACf,WAAW;MACX,UAAU;MACV,gBAAgB,EAAA;MAlGtB;QAoGQ,iBAAiB;QACjB,aAAa;QACb,gBAAgB;QAChB,oBAAoB,EAAA;QE7I1B;UFsCF;YAyGU,kBAAkB,EAAA,EAErB;IA3GP;MA+GM,YAAY;MACZ,uBCjJY;MDkJZ,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,cAAc,EAAA;IApHpB;MAwHM,aAAa;MACb,YAAY;MACZ,iDAAiD,EAAA;IA1HvD;MA6HM,aAAa;MACb,YAAY;MACZ,iDAAiD,EAAA;IA/HvD;MAkIM,aAAa;MACb,YAAY;MACZ,mDAAmD,EAAA;IApIzD;MAwIM,aAAa;MACb,gBAAgB;MAChB,iBAAiB,EAAA;MEhLrB;QFsCF;UA4IQ,iBAAiB,EAAA,EAEpB;;AAIL;EACE,yBAAyB;EACzB,2BAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAA;EARpB;IAUI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAA;EAlBhB;IAqBI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB,EAAA","sourcesContent":[".centered-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.singleLineText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.width-fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: fill-available;\n}\n\n.height-fill-available {\n  height: 100%;\n  height: -moz-available; /* WebKit-based browsers will ignore this. */\n  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  height: fill-available;\n}\n","@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/classes.scss\";\n@import \"src/modules/Core/styles/mixins.scss\";\n\n@keyframes drop {\n  0% {\n    transform: translateY(0vh);\n  }\n\n  75% {\n    transform: translateY(75vh);\n  }\n  100% {\n    transform: translateY(100vh);\n  }\n}\n\n@keyframes ascend {\n  0% {\n    transform: translateY(100vh);\n  }\n  75% {\n    transform: translateY(75vh);\n  }\n  100% {\n    transform: translateY(0vh);\n  }\n}\n@keyframes pulsating {\n  0% {\n    transform: scale(1);\n    background-color: $grey72;\n    opacity: 0.18;\n  }\n  50% {\n    transform: scale(1.8);\n    background-color: #3c3b3b;\n    opacity: 0.72;\n  }\n  100% {\n    transform: scale(1);\n    background-color: $grey90;\n    opacity: 0.18;\n  }\n}\n\n.node {\n  position: absolute;\n  background-color: #3c3b3b;\n\n  border-radius: 100%;\n  height: 1.8rem;\n  width: 1.8rem;\n  overflow: hidden;\n  transition: 1s all ease-in;\n  border: 0.1rem solid $grey;\n  cursor: pointer;\n  transform: translateX(-0.9rem) translateY(0.9rem);\n  z-index: 2;\n  overflow: visible;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  &.extra-small {\n    max-height: 0.5rem;\n    max-width: 0.5rem;\n    z-index: -1;\n  }\n\n  &.dropping {\n    animation: drop 10s linear infinite;\n  }\n\n  &.ascending {\n    animation: ascend 10s linear infinite;\n  }\n\n  &.pulsating {\n    animation: pulsating 5s linear infinite;\n  }\n\n  &.quote {\n    & .textContentContainer {\n      display: flex;\n      flex-direction: column-reverse;\n      & h4 {\n        font-size: 1rem;\n        text-align: right;\n        width: 100%;\n      }\n    }\n    & .btn {\n      align-self: flex-start;\n      align-self: center;\n      &::after {\n        display: none;\n      }\n    }\n  }\n\n  & .elipsis {\n    border-width: 0.25rem;\n    border-color: $grey5;\n    border-style: ridge;\n    padding: 0.07rem;\n    width: 120%;\n    height: 150%;\n    border-radius: 100%;\n    position: absolute;\n    opacity: 0.25;\n    transform: 1s all ease-in;\n\n    &:nth-child(2) {\n      rotate: 90deg;\n    }\n    &:nth-child(3) {\n      rotate: 180deg;\n    }\n\n    &:nth-child(4) {\n      rotate: 342deg;\n    }\n\n    &:nth-child(5) {\n      rotate: 216deg;\n    }\n  }\n  & > div:first-child {\n    z-index: 10;\n    display: none;\n    justify-content: center;\n    flex-direction: column;\n  }\n  z-index: 1;\n  &.open {\n    z-index: 9999909999;\n    & > div:first-child {\n      display: flex;\n      background-color: $grey18;\n      border-radius: 100%;\n      padding: 1.8rem;\n      height: 90%;\n      width: 90%;\n      overflow: hidden;\n      & p {\n        font-size: 1.1rem;\n        margin: unset;\n        font-weight: 600;\n        line-height: 1.25rem;\n        @include mobile {\n          font-size: 0.75rem;\n        }\n      }\n    }\n\n    & .elipsis {\n      opacity: 0.5;\n      border-color: $grey18;\n      border-width: 0.18rem;\n      width: 107%;\n      height: 136%;\n      padding: unset;\n    }\n    border: 0.1rem solid $grey10;\n    &.medium {\n      height: 18rem;\n      width: 18rem;\n      transform: translateX(-9.9rem) translateY(9.9rem);\n    }\n    &.small {\n      height: 15rem;\n      width: 15rem;\n      transform: translateX(-8.4rem) translateY(8.4rem);\n    }\n    &.large {\n      height: 30rem;\n      width: 30rem;\n      transform: translateX(-15.9rem) translateY(15.9rem);\n    }\n    background-color: #fff;\n    h4 {\n      margin: unset;\n      font-weight: 800;\n      font-size: 1.5rem;\n      @include mobile {\n        font-size: 0.9rem;\n      }\n    }\n  }\n}\n\n.btn {\n  transform: 1s all ease-in;\n  color: $grey90 !important   ;\n  width: fit-content;\n  align-self: flex-end;\n  max-width: 90%;\n  display: flex;\n  align-items: center;\n  max-height: 1.8rem;\n  &::after {\n    transition: 0.5s all;\n    content: \"\\203A\";\n    font-size: 1.5rem;\n    color: #808080e6;\n    cursor: pointer;\n    padding: 0rem 0.5rem;\n    display: flex;\n    align-items: center;\n    height: 100%;\n  }\n  &:hover {\n    color: #3c3b3b;\n    opacity: 1;\n    font-weight: 700;\n    background-color: unset;\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered-col": `styles_centered-col__hWHwH`,
	"hide-scrollbar": `styles_hide-scrollbar__7bvEE`,
	"singleLineText": `styles_singleLineText__CyRDB`,
	"width-fill-available": `styles_width-fill-available__mhjhJ`,
	"height-fill-available": `styles_height-fill-available__k-h2s`,
	"node": `styles_node__KrAlJ`,
	"extra-small": `styles_extra-small__Vvu0B`,
	"dropping": `styles_dropping__GzSsX`,
	"drop": `styles_drop__vSeru`,
	"ascending": `styles_ascending__mY1d5`,
	"ascend": `styles_ascend__24bqS`,
	"pulsating": `styles_pulsating__P8BrF`,
	"quote": `styles_quote__W7AiS`,
	"textContentContainer": `styles_textContentContainer__oOI0n`,
	"btn": `styles_btn__v88WE`,
	"elipsis": `styles_elipsis__LrC3C`,
	"open": `styles_open__N6CRM`,
	"medium": `styles_medium__q7fSk`,
	"small": `styles_small__N9OQd`,
	"large": `styles_large__xb8i8`
};
export default ___CSS_LOADER_EXPORT___;
